<template>
  <div class="detail-container" style="height:100%;overflow:hidden;">
    <el-scrollbar class="detail-container-content" :style="$slots.footer ? 'height:calc(100% - 44px);overflow:hidden;' : 'overflow:hidden;height:100%;'"><slot /></el-scrollbar>
    <div class="detail-container-footer" v-if="$slots.footer">
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-detail-container'
}
</script>
<style lang="less">
.detail-container {
  position: relative;
  background: #fff;
  height: 100%;
  .el-scrollbar__bar.is-horizontal {
    display: none;
  }
  .el-scrollbar__wrap {
      overflow-x: hidden;
  }
  &-footer {
    position: absolute;
    left: 0;
    right: 0;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow:0px 2px 12px 0px rgba(215,215,215,0.3);
    z-index: 1000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/detail/container.vue